import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const text: ComponentTemplate = {
  id: "392a5f71-91c2-407a-b15d-a0adb152406c",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Basic/Text",
  leftBarCategory: { main: "basic", subCategory: "text" },
  preview: "basic/text.svg",

  transforms: [],
  template: {
    id: "29d75728-b9bb-4581-80e4-ff66a2f0557d",
    type: "text",
    props: {
      text: "<p>Add new text here</p>",
      style: {
        fontSize: "20px",
        lineHeight: "24px",
      },
    },
  },
};
